import MS from 'constants/time/ms.const';
import { fromAnyDateToTimestamp, fromAnyDateToZulu } from 'utils/converters/time/from.util';
import logger from 'utils/logger.util';
import isNotSafeInteger from 'utils/predicates/number/isNotSafeInteger.util';

const L = logger('downToQuarter'); // eslint-disable-line no-unused-vars

const GRANULARITY = 15 * MS.minute;

const downToQuarter = (date) => {
  const timestamp = fromAnyDateToTimestamp(date);
  if (isNotSafeInteger(timestamp)) return NaN;

  return fromAnyDateToZulu(timestamp - (timestamp % GRANULARITY));
};

export default downToQuarter;
